import { render, staticRenderFns } from "./TemplatePageNavigator.vue?vue&type=template&id=2f99fa50"
import script from "./TemplatePageNavigator.vue?vue&type=script&lang=js"
export * from "./TemplatePageNavigator.vue?vue&type=script&lang=js"
import style0 from "./TemplatePageNavigator.vue?vue&type=style&index=0&id=2f99fa50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports